import { Link } from 'react-router-dom'
import { TeamMember } from '@/types'
import { getImageUrl } from '@/utils/helpers'
import './FeaturedTeam.css'

interface FeaturedTeamProps {
  teamMembers: TeamMember[]
}

function FeaturedTeam({ teamMembers }: FeaturedTeamProps) {
  if (teamMembers.length === 0) {
    return null
  }

  return (
    <section className="featured-team">
      <div className="container">
        <h2 className="section-title">Notre équipe</h2>
        <p className="section-subtitle">
          Rencontrez les personnes engagées qui font avancer ce projet
        </p>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-card-image">
                {member.photo?.url ? (
                  <img src={getImageUrl(member.photo.url)} alt={member.name} />
                ) : (
                  <div className="team-card-placeholder">
                    <span>{member.name.charAt(0)}</span>
                  </div>
                )}
              </div>
              <div className="team-card-content">
                <h3 className="team-card-name">{member.name}</h3>
                <p className="team-card-role">{member.role}</p>
                <p className="team-card-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="section-cta">
          <Link to="/equipe" className="btn btn-primary">
            Voir toute l'équipe
          </Link>
        </div>
      </div>
    </section>
  )
}

export default FeaturedTeam
